/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"

import { useStaticQuery, graphql } from "gatsby"

type metaType = { name: string; content: string }
type Props = {
  description?: string
  lang?: string
  meta?: metaType[]
  title?: string
}
function SEO({ description = ``, title = "HDMK Home Inspections" }: Props) {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          author
        }
      }
    }
  `)

  const metaDescription = description || site.siteMetadata.description

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={metaDescription} />
      <meta
        name="viewport"
        content={`width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0`}
      />
      <meta
        name="viewport"
        content={`width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0`}
      />
      <meta
        name="viewport"
        content={`width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0`}
      />

      <link
        rel="preconnect"
        href="https://fonts.googleapis.com/css2?family=Mulish:wght@400;700&display=swap"
      />
    </>
  )
}
{
  /* <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `viewport`,
          content: `width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0`,
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    /> */
}
export default SEO
